import { Affiliate } from "@/types";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import {
  sanitizeFieldRestProps,
  useGetPathForRecord,
  useRecordContext,
} from "react-admin";
import { useNavigate } from "react-router-dom";
import { UserNameCellProps } from "./user-name-cell.types";

const UserNameCell: FC<UserNameCellProps> = ({ resourceName, ...props }) => {
  const navigate = useNavigate();
  const user = useRecordContext<Affiliate>();
  const recordPath = useGetPathForRecord({
    record: user,
    resource: resourceName,
  });

  const onRowClick = () => {
    navigate(recordPath || "", {
      state: { _scrollToTop: true },
    });
  };

  if (!user) return null;

  return (
    <Stack
      direction={"row"}
      spacing={2}
      sx={{ cursor: "pointer" }}
      alignItems={"center"}
      onClick={onRowClick}
      {...sanitizeFieldRestProps(props)}
    >
      <Typography component="span" variant="body2" noWrap={true}>
        {user.fullName}
      </Typography>
    </Stack>
  );
};

export { UserNameCell };
